/**
 * Created by Jew on 7/6/2017.
 */
import { Component, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { TranslateService } from '@ngx-translate/core';
import { IdexService } from 'app/idex.service';
import { Path } from 'app/shared/path';
import { Toast } from 'app/shared/toast/toast';
import { Subject } from 'rxjs';
import { OneDrive } from './onedrive.service';
import { WaitForImportComponent } from '../google-drive/wait-for-import.component';

declare const microsoft: string;

@Component({
   selector: 'app-create-onedrive-dialog',
   templateUrl: 'create-onedrive.component.html',
   styleUrls: ['create-onedrive.component.css']
})
export class CreateOneDriveComponent implements OnInit {
   doctype: 'document' | 'sheet' | 'presentation';
   type: 'Word Document' | 'Excel Spreadsheet' | 'PowerPoint Presentation';
   error: any;
   /** Path (after "/drive/root:/") to folder destination. Empty string = root */
   path: string;
   code: any;
   item: HTMLInputElement;
   storedAppInfo: any = null;
   clientId = microsoft;
   redirectUri: any = Path.getAppUrl('callback');
   scope: any = 'files.readwrite';
   isBusiness: boolean;
   public canDrag: boolean;
   // scopes: any = 'wl.basic wl.offline_access wl.signin onedrive.readwrite';

   /**
    * Subject to emit the dialog result AFTER the dialog is closed.
    */
   result = new Subject();
   /**
    * Observable to subscribe the dialog result AFTER the dialog is closed.
    */
   result$ = this.result.asObservable();

   constructor(
      private dialogRef: MatDialogRef<CreateOneDriveComponent>,
      @Inject(MAT_DIALOG_DATA)
      public data: {
         from: string;
         isFolder: false;
         parentId: string;
         conflictBehavior: 'fail' | 'replace' | 'rename';
      },
      public dialog: MatDialog,
      private translate: TranslateService,
      private onedrive: OneDrive,
      private service: IdexService,
      private container: ViewContainerRef,
      private toast: Toast
   ) {}

   ngOnInit() {
      if (this.doctype === 'document') {
         this.type = 'Word Document';
      } else if (this.doctype === 'sheet') {
         this.type = 'Excel Spreadsheet';
      } else if (this.doctype === 'presentation') {
         this.type = 'PowerPoint Presentation';
      }
      window.addEventListener('message', () => {
         if (this.onedrive.action === 'create') {
            this.createFile(this.item);
            this.onedrive.action = '';
         }
      });
   }

   signInToOneDrive() {
      const appInfo = {
         clientId: this.clientId,
         redirectUri: this.redirectUri,
         scopes: this.scope,
         authServiceUri: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize'
      };
      this.provideAppInfo(appInfo);
      // use Microsoft Graph v1.0
      const baseUrl = this.getQueryVariable('baseUrl');
      const msGraphApiRoot = baseUrl ? baseUrl : 'https://graph.microsoft.com/v1.0/me';

      this.challengeForAuth();
      this.saveToCookie({ apiRoot: msGraphApiRoot, signedin: true });
      return false;
   }

   createFile(item: HTMLInputElement) {
      if (item.value.trim().length === 0) {
         item.focus();
         return;
      }
      if (/[<|>\\\/:?*"]/g.test(item.value)) {
         this.translate.get('alert.create_folder_error').subscribe((s) => {
            this.error = s;
         });
         return;
      }
      if (item.value.lastIndexOf('.') === item.value.length - 1) {
         this.translate.get('alert.create_folder_error_dot').subscribe((s) => {
            this.toast.error(s);
         });
         return;
      }
      if (window.localStorage.getItem('access_token') === null) {
         this.item = item;
         this.onedrive.signIn('create');
      } else {
         let waiting: any;
         if(this.data.from === 'dms'){
            this.dialogRef.close();
            const dialogRef = this.dialog.open(WaitForImportComponent, {disableClose: true, data: this.data});
            waiting = dialogRef.componentInstance;
            waiting.path = this.path;
            this.translate.get('onedrive.create').subscribe(s => {
               waiting.message = s;
            });
         }
         if (this.data.isFolder) {
            this.service
               .onedrive_createFolder(
                  localStorage.getItem('access_token'),
                  item.value.trim(),
                  this.data.parentId,
                  'fail'
               )
               .subscribe(
                  (res) => {
                     if(this.data.from === 'dms'){
                        this.dmsCaseCreateOnedrive(res, waiting, item);
                     }else{
                        this.dialogRef.close();
                        this.result.next(res);
                     }
                  },
                  (error) => {
                     if (error.status === 409) {
                        this.translate
                           .get('onedrive.error.nameAlreadyExists', { name: item.value.trim() })
                           .subscribe((s) => {
                              this.toast.error(s);
                           });
                     }
                  }
               );
         } else {
            this.service
               .onedrive_create(
                  localStorage.getItem('access_token'),
                  this.doctype,
                  item.value.trim(),
                  this.data.parentId,
                  this.data.conflictBehavior,
               )
               .subscribe(
                  (data) => {
                     if(this.data.from === 'dms'){
                        this.dmsCaseCreateOnedrive(data, waiting, item);
                     }else{
                        this.dialogRef.close();
                        this.result.next(data);
                        window.open(data.webUrl, '_blank');
                     }
                  },
                  (error) => {
                     if (error.status === 401 || (error.status === 500 && error.message === 'Stream closed')) {
                        this.item = item;
                        localStorage.removeItem('access_token');
                        this.onedrive.signIn('create');
                     } else {
                        this.toast.error(error.message);
                        localStorage.removeItem('access_token');
                     }
                  }
               );
         }
      }
      this.dialogRef.close(this.result$);
   }

   provideAppInfo(obj: any) {
      this.storedAppInfo = obj;
   }

   getQueryVariable(variable: any) {
      const query = window.location.search.substring(1);
      const vars = query.split('&');
      for (let i = 0; i < vars.length; i++) {
         const pair = vars[i].split('=');
         if (pair[0] === variable) {
            return pair[1];
         }
      }
      return false;
   }

   challengeForAuth() {
      const appInfo = this.getAppInfo();
      let url =
         appInfo.authServiceUri +
         '?client_id=' +
         appInfo.clientId +
         '&response_type=token' +
         '&redirect_uri=' +
         encodeURIComponent(appInfo.redirectUri);

      if (appInfo.scopes) {
         url = url + '&scope=' + encodeURIComponent(appInfo.scopes);
      }
      if (appInfo.resourceUri) {
         url = url + '&resource=' + encodeURIComponent(appInfo.resourceUri);
      }

      this.popup(url);
   }

   getAppInfo() {
      if (this.storedAppInfo) {
         return this.storedAppInfo;
      }

      const scriptTag = document.getElementById('odauth');
      if (!scriptTag) {
         alert('the script tag for odauth.js should have its id set to "odauth"');
      }

      const clientId = scriptTag.getAttribute('clientId');
      if (!clientId) {
         alert('the odauth script tag needs a clientId attribute set to your application id');
      }

      const scopes = scriptTag.getAttribute('scopes');
      // scopes aren't always required, so we don't warn here.

      const redirectUri = scriptTag.getAttribute('redirectUri');
      if (!redirectUri) {
         alert('the odauth script tag needs a redirectUri attribute set to your redirect landing url');
      }

      const resourceUri = scriptTag.getAttribute('resourceUri');

      const authServiceUri = scriptTag.getAttribute('authServiceUri');
      if (!authServiceUri) {
         alert('the odauth script tag needs an authServiceUri attribtue set to the oauth authentication service url');
      }

      const appInfo = {
         clientId: clientId,
         scopes: scopes,
         redirectUri: redirectUri,
         resourceUri: resourceUri,
         authServiceUri: authServiceUri
      };

      this.storedAppInfo = appInfo;

      return appInfo;
   }

   popup(url: any) {
      const width = 525,
         height = 525,
         screenX = window.screenX,
         screenY = window.screenY,
         outerWidth = window.outerWidth,
         outerHeight = window.outerHeight;

      const left = screenX + Math.max(outerWidth - width, 0) / 2;
      const top = screenY + Math.max(outerHeight - height, 0) / 2;

      const features = [
         'width=' + width,
         'height=' + height,
         'top=' + top,
         'left=' + left,
         'status=no',
         'resizable=yes',
         'toolbar=no',
         'menubar=no',
         'scrollbars=yes'
      ];
      const popup = window.open(url, 'oauth', features.join(','));
      if (!popup) {
         alert('failed to pop up auth window');
      }

      popup.focus();
   }

   saveToCookie(obj: any) {
      const expiration = new Date();
      expiration.setTime(expiration.getTime() + 3600 * 1000);
      const data = JSON.stringify(obj);
      let cookie = 'odexplorer=' + data + '; path=/; expires=' + expiration.toUTCString();
      if (document.location.protocol.toLowerCase() === 'https') {
         cookie = cookie + ';secure';
      }
      document.cookie = cookie;
   }

   dmsCaseCreateOnedrive(data, waiting, item){
      if(!this.data.isFolder){
         window.open(data.webUrl, '_blank');
      }
      waiting.progress = false;
      waiting.status = 'onedrive';
      waiting.id = data.id;
      waiting.name = item.value;
      waiting.isBusiness = this.isBusiness;
      this.translate.get('onedrive.save').subscribe(s => {
         waiting.message = s;
      });
      this.translate.get('onedrive.saveText').subscribe(s => {
         waiting.saveText = s;
      });
      waiting.update();
   }
}
